<script setup>
import {defineProps, ref} from "vue";
import NextButton from "../NextButton.vue";
import Lock from "../../../../../../franchise-listings/assets/svg/LockSimpleWhite.svg";

const {flowState} = defineProps(['visible', 'flowState']);

const errors = ref({
	email: false,
	firstName: false,
	lastName: false,
});


const onEmailChange = (e) => {
	flowState.setFormValue('email', e.target.value.trim());
};

const onFirstNameChange = (e) => {
	flowState.setFormValue('firstName', e.target.value.trim());
}

const onLastNameChange = (e) => {
	flowState.setFormValue('lastName', e.target.value.trim());
}

const onSignUpChange = () => {
	flowState.value.consultWithSpecialist === 'Yes' ? flowState.setFormValue('signUp', true) : flowState.setFormValue('signUp', false);
};

// Validations
let onlyLetters = /^[a-zA-Z�-�\u00f1\u00d1\u00E0-\u00FC]+$/;
const emailRegex = /^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*(\+[a-zA-Z0-9-]+)?@[a-z0-9-.]+(\.[a-zA-Z0-9]+)$/;

const checkInvalid = (field) => {
	// Get field value
	const fieldData = flowState.value[field];

	// Validate fields
	if (field === 'firstName' || field === 'lastName') {
		if (fieldData === '') {
			errors.value[field] = 'Field is required';
		} else if (!onlyLetters.test(fieldData)) {
			errors.value[field] = 'Enter a valid Name';
		} else {
			errors.value[field] = false;
		}
	} else if (field === 'email') {
		if (fieldData === null || fieldData === '') {
			errors.value[field] = 'Email is required';
		} else if (!emailRegex.test(fieldData)) {
			errors.value[field] = 'Invalid email';
		} else {
			errors.value[field] = false;
		}
	}
}

const checkErrors = () => {
	return errors.value.firstName === false
		&& errors.value.lastName === false
		&& errors.value.email === false;
}

const notNullValues = () => {
	return flowState.value.firstName !== null &&
		flowState.value.lastName !== null &&
		flowState.value.email !== null &&
		flowState.value.consultWithSpecialist !== null;
}

const stepIsReady = () => {
	// Check if all fields are filled and valid
	return checkErrors() && notNullValues();
}

const checkNextStep = async () => {

	// Hide button and show loader
	$('.btn-next-orange').hide();
	$('#loadingBtnCta').show();

	// Clear error message
	$('#showPhoneErrorMessage').hide();

	try {
		// Save fist step data
		await flowState.services.submitNameEmail(flowState.userData());

		if(flowState.value.consultWithSpecialist === 'Yes'){
			flowState.next();
		} else {
			// Send data to Hubspot
			flowState.setHubspotStatus();

			// Go to last step
			flowState.goToStep(3);
		}

	} catch (e) {
		console.log(e)
	}

}

</script>

<template>
	<div v-if="visible">
		<div class="tab">
			<div class="row my-4">
				<h3 class="tab-title-cta text-center text-white">Access the <strong>free</strong> business plan and forecasting model:</h3>
			</div>
			<div class="row mt-0 mb-0">
				<div class="col-12 col-md-3">
					<p class="small-text-normal mb-1 text-white">First name<span class="text-warning ms-1">*</span></p>
					<p>
						<input
							type="text"
							placeholder="John"
							:value="flowState.value.firstName"
							@change="onFirstNameChange"
							@blur="checkInvalid('firstName')"
						/>
						<span v-if="errors.firstName !== false" class="validationMessage text-warning ps-2 pe-2">
              {{ errors.firstName }}
            </span>
					</p>
				</div>
				<div class="col-12 col-md-3">
					<p class="small-text-normal mb-1 text-white">Last name<span class="text-warning ms-1">*</span></p>
					<p>
						<input
							type="text"
							placeholder="Doe"
							:value="flowState.value.lastName"
							@change="onLastNameChange"
							@blur="checkInvalid('lastName')"
						/>
						<span v-if="errors.lastName !== false" class="validationMessage text-warning ps-2 pe-2">
              {{ errors.lastName }}
            </span>
					</p>
				</div>
				<div class="col-12 col-md-6">
					<p class="small-text-normal mb-1 text-white">Your email<span class="text-warning ms-1">*</span></p>
					<p>
						<input
							id="email"
							type="text"
							placeholder="example@mail.com"
							@change="onEmailChange"
							@blur="checkInvalid('email')"
							:value="flowState.value.email"
						/>
						<span v-if="errors.email" class="validationMessage text-warning ps-2 pe-2">
                        {{ errors.email }}
                    </span>
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 mt-3 mb-3">
					<p class="fw-normal mb-2 fs-5 text-white">
						Would you like a <strong>free, personalized</strong> consultation with a vetted franchise specialist?
						<span class="text-warning ms-1">*</span>
					</p>
					<div class="mt-2 consult-specialist">
						<input type="radio" id="three" value="Yes" v-model="flowState.value.consultWithSpecialist" @change="onSignUpChange" />
						<label class="checkbox-text text-white me-4 ps-1" for="three">Yes</label>
						<input type="radio" id="four" value="No" v-model="flowState.value.consultWithSpecialist" @change="onSignUpChange" />
						<label class="checkbox-text text-white me-5 ps-1" for="four">No</label>
					</div>
				</div>
			</div>
			<div id="showPhoneErrorMessage" class="row p-3 mt-3 pb-0">
				<div class="col col-12 p-3 mb-0">
					<p class="mb-0 d-flex align-items-center text-white">
						<Lock/>
						We could not send a verification text to the phone number provided. Please correct your phone number and
						resubmit.
					</p>
				</div>
			</div>
			<div>
				<NextButton
					:text="flowState.nextButtonText()"
					:enabled="stepIsReady()"
					@click="() => { checkNextStep() }"
				/>
				<div id="loadingBtnCta" class="mt-4">
					<span id="loaderorange"></span>
				</div>
			</div>
			<div class="row mt-4 justify-content-center">
				<span class="col-11 disclaimer text-white text-center">By clicking the button above, you acknowledge, consent, and agree to our <a class="text-white" href="https://www.vettedbiz.com/terms-of-use/" target="_blank">Terms & Conditions</a> and
					<a class="text-white" href="https://www.vettedbiz.com/privacy-policy/" target="_blank">Privacy Policy</a> and consent to receive notices and other communications electronically. These communications may come in the form of
					email, text and/or calls.</span>
			</div>
		</div>
	</div>
</template>